export const IncentiveConstants = {
    USER_INCENTIVE_LEAD_LIST: 'USER_INCENTIVE_LEAD_LIST'
};